import { Box, Stack, Typography } from '@mui/material';
import { filterFixedProducts } from '@vy/services';
import type { FixedProduct, Plan } from '@vy/types';
import { ChartModernSquare } from '@vy/ui-design-system';
import { FC } from 'react';

const BANNER_BACKGROUND_COLOR = '#E7F2FF';
const BANNER_TEXT_COLOR = '#152232';
const BANNER_ICON_COLOR = '#0521FF';

type ContractUpliftBannersProps = {
  plan: Plan;
};

export const ContractUpliftBanners: FC<ContractUpliftBannersProps> = ({ plan }) => {
  const fixedProducts = filterFixedProducts<FixedProduct>(plan.products);

  const hasInflationaryUplift = fixedProducts.some(
    (product) => product.upliftConfiguration?.inflationaryUpliftEnabled,
  );
  const hasSeatUplift = fixedProducts.some(
    (product) => product.upliftConfiguration?.seatUpliftEnabled,
  );

  if (!hasInflationaryUplift && !hasSeatUplift) {
    return null;
  }

  return (
    <Stack spacing={1} sx={{
      mt: 3
    }}>
      {hasInflationaryUplift && (
        <UpliftBanner text="Price Policy - automated annual inflationary uplift" />
      )}
      {hasSeatUplift && (
        <UpliftBanner text="Growth Policy - automated annual seats ramp up" />
      )}
    </Stack>
  );
};

function UpliftBanner({ text }: { text: string }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '14px 12px',
        backgroundColor: BANNER_BACKGROUND_COLOR,
        borderRadius: '8px',
      }}
    >
      <Box sx={{ display: 'flex', flexShrink: 0, color: BANNER_ICON_COLOR, '& path, & rect': { stroke: 'currentColor' } }}>
        <ChartModernSquare width={20} height={20} viewBox="0 0 24 24" />
      </Box>
      <Typography variant="body2" color={BANNER_TEXT_COLOR} sx={{
        fontWeight: 500
      }}>
        {text}
      </Typography>
    </Box>
  );
}
